import axios from "axios";
import { COMMON_CORE_BASE_URL } from "./Url";

export function LoginCall(data){
    return axios.post(COMMON_CORE_BASE_URL+'login',data);
}
